
        var result = require("!!../../../../node_modules/css-loader/index.js!./home-card-show.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/home-card-show/home-card-show.component.css
// module id = 601
// module chunks = 0